import React from 'react'
import moment from 'moment'

import WaitingIcon from '@material-ui/icons/Schedule'
import ApprovedIcon from '@material-ui/icons/Done'
import DeclinedIcon from '@material-ui/icons/Clear'
import FaceIcon from '@material-ui/icons/Face'
import DateIcon from '@material-ui/icons/Schedule'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import InfoIcon from '@material-ui/icons/InfoOutlined'
import FormatQuoteIcon from '@material-ui/icons/FormatQuote'
import { Chip, Avatar, Box } from '@material-ui/core'

export const CreditRequestButton = props => {
  const { self, label, bank, creditRequest, downloadFile } = props

  const Lower = name => {
    return name.charAt(0).toLowerCase() + name.substring(1)
  }

  const Capitalize = name => {
    return name.charAt(0).toUpperCase() + name.slice(1)
  }

  let bankName = bank.primary === 'EurasianBank' ? 'eurasian' : bank.primary
  const isSent = creditRequest?.[`sentTo${bank.primary}`]
  const isAlternative = creditRequest?.[`${Lower(bankName)}IsAlternative`]
  const isApproved = creditRequest?.[`approvedBy${bank.primary}`]
  const sentBy = creditRequest?.[`sentTo${bank.primary}ByName`]
  const sentDate = creditRequest?.[`${Lower(bank.primary)}SendDate`]
  const productCode =
    bank.secondary && creditRequest?.[`${bank.secondary}ProductCode`]
  const status = bank.secondary && creditRequest?.[`${bank.secondary}Status`]
  const decision = creditRequest?.[`${Lower(bankName)}Decision`]
  const decisionDesc = creditRequest?.[`${Lower(bankName)}DecisionDescription`]
  const selectedBank = Lower(
    bank.primary === 'EurasianBank' ? bank.secondary : bank.primary
  )
  const updatedBy =
    creditRequest[
      `updated${
        bank.primary === 'EurasianBank'
          ? Capitalize(bank.secondary)
          : bank.primary
      }StatusByUsername`
    ]
  const updatedDate =
    creditRequest[
      `${Lower(
        bank.primary === 'EurasianBank' ? bank.secondary : bank.primary
      )}StatusUpdatedDate`
    ]

  const GetIcon = () => {
    if (isApproved === undefined || isApproved === null) {
      return <WaitingIcon />
    }

    if (isApproved === true) {
      return <ApprovedIcon />
    }

    if (isApproved === false) {
      return <DeclinedIcon />
    }
  }

  const getStyle = () => {
    if (isApproved === undefined || isApproved === null) {
      return {
        chip: { fontWeight: '600', fontSize: '14px' },
        avatar: {}
      }
    }

    if (isApproved === true) {
      return {
        chip: {
          backgroundColor: updatedBy ? '#A0E7E5' : '#15C134',
          color: '#FFF',
          fontWeight: '600',
          fontSize: '14px'
        },
        avatar: {
          backgroundColor: '#0E8706',
          color: '#FFF'
        }
      }
    }

    if (isApproved === false) {
      return {
        chip: {
          backgroundColor: updatedBy ? '#FFAEBC ' : '#F40101',
          color: '#FFF',
          fontWeight: '600',
          fontSize: '14px'
        },
        avatar: {
          backgroundColor: '#A60404',
          color: '#FFF'
        }
      }
    }
  }

  const description = [decision, decisionDesc, updatedBy, updatedDate]
    .filter(t => !!t)
    .join(' ')

  return isSent ? (
    <Box flex flexDirection={'column'}>
      <div className="chips-container">
        <Chip
          style={getStyle().chip}
          onClick={() =>
            isApproved === undefined || isApproved === null
              ? self.setState({
                  selectedBank: selectedBank,
                  isProcessCreditRequestOpen: true
                })
              : self.setState({
                  selectedBank: selectedBank,
                  isAlternativeDialogOpen: true
                })
          }
          avatar={
            <Avatar component={'div'} style={getStyle().avatar}>
              <GetIcon />
            </Avatar>
          }
          label={label}
        />
        {sentBy && (
          <Chip variant="outlined" icon={<FaceIcon />} label={sentBy} />
        )}
        {sentDate && (
          <Chip
            variant="outlined"
            icon={<DateIcon />}
            label={moment(sentDate).format('DD.MM.YYYY HH:mm')}
          />
        )}
        {productCode !== '' && productCode !== undefined && (
          <Chip
            variant="outlined"
            icon={<ShoppingCartIcon />}
            label={productCode}
          />
        )}
        {status !== '' && status !== undefined && (
          <Chip variant="outlined" icon={<InfoIcon />} label={status} />
        )}
        {isAlternative && (
          <Chip
            style={{ backgroundColor: '#FFC300' }}
            variant="outlined"
            label={'Альтернатива'}
          />
        )}
        {bank.label === 'БЦК' && creditRequest.bccWarrantyLetterLocation && (
          <Chip
            style={{ backgroundColor: '#55e655' }}
            variant="outlined"
            label={'Скачать ГП'}
            onClick={() => {
              downloadFile(creditRequest.id, 'bccWarrantyLetter')
            }}
          />
        )}
      </div>
      {description && (
        <Box
          style={{
            fontStyle: 'italic',
            backgroundColor: '#00c4ff0f',
            border: '1px solid #6FC4FF5A',
            padding: 5
          }}
        >
          <FormatQuoteIcon style={{ color: '#CCC' }} />
          {description}
        </Box>
      )}
    </Box>
  ) : (
    <div></div>
  )
}
